<template>
    <div
        style="max-width: 600px; margin: auto; text-align: left;"
        :class="field.options?.inline ? 'text-field-inline' : 'text-field-stack'"
    >
        <FieldHeader
            v-if="showHeader"
            :class="field.options?.inline ? 'q-mb-none q-mr-md text-field-header-inline' : 'q-mb-xs'"
            :field="field"
        />
        <q-input
            filled
            dense
            type="textarea"
            autogrow
            :placeholder="field.options?.placeholder || 'Enter your response here...'"
            :maxlength="field.options?.maxLength || 2000"
            :model-value="modelValue"
            :readonly="readOnly"
            :class="field.options?.inline ? 'text-field-input-inline' : ''"
            @update:model-value="onUpdate"
        />
    </div>
</template>

<script>
    import FieldHeader from './FieldHeader.vue';

    export default {
        name: 'TextField',
        components: { FieldHeader },
        props: {
            field: {
                type: Object,
                required: true,
            },
            modelValue: {
                type: String,
                default: '',
            },
            readOnly: {
                type: Boolean,
                default: false,
            },
            showHeader: {
                type: Boolean,
                default: true,
            },
        },
        emits: ['update:modelValue', 'blur'],
        methods: {
            onUpdate(value) {
                this.$emit('update:modelValue', value);
                this.$emit('blur');
            },
        },
    };
</script>

<style scoped>
    .text-field-inline {
        display: flex;
        align-items: center;
    }

    .text-field-header-inline {
        flex: 0 0 auto;
        min-width: 180px;
    }

    .text-field-input-inline {
        flex: 1 1 auto;
    }
</style>